import type { ProvenanceDetailResponse } from '@vivport/backend/types';

interface ProvenancePaneHeaderProps {
  detail: ProvenanceDetailResponse;
}

function composeLabel(detail: ProvenanceDetailResponse): string {
  if (detail.subtypeData.kind === 'PROCESS_RUN') {
    const label = detail.subtypeData.processNameSnapshot ?? 'Process run';
    const parts = [label];
    if (detail.status) parts.push(detail.status);
    if (detail.memberName) parts.push(detail.memberName);
    return parts.join(' · ');
  }
  if (detail.subtypeData.kind === 'MANUAL_SESSION') {
    const state = detail.closedAt === null
      ? 'Active'
      : `Closed · ${detail.closeReason ?? 'closed'}`;
    const parts = [state];
    if (detail.memberName) parts.push(detail.memberName);
    return parts.join(' · ');
  }
  const title = detail.title?.trim() || 'Neo chat';
  const description = detail.description?.trim() ?? '';
  return [title, description].filter(Boolean).join(' · ');
}

export function ProvenancePaneHeader({ detail }: ProvenancePaneHeaderProps) {
  const label = composeLabel(detail);
  return (
    <div className="px-4 pt-2 pb-2">
      <div className="min-h-0 min-w-0 flex items-center gap-0.5">
        <div className="min-h-0 min-w-0 flex-1 truncate py-0 text-left text-xs leading-snug text-muted-foreground">
          {label}
        </div>
      </div>
    </div>
  );
}
